
{
  "labels": {
    "select-location": "Select your location"
  }
}
